'use client';
import { ReactNode, useEffect, useState } from 'react';
import { setShowedToast, wasToastShowed } from '../../utils';

interface IShowToast {
  children: ReactNode;
  name: string;
}

export const ShowToast = ({ children, name = '' }: IShowToast) => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (wasToastShowed(name)) {
      setShowToast(false);
    } else {
      setShowToast(true);
    }
  }, [name]);

  if (!showToast) {
    return;
  }
  setShowedToast(name);

  return <>{children}</>;
};
